// Facebook SDK helper for OAuth login
// Uses the FB SDK loaded in index.html

export function fbLogin() {
  return new Promise((resolve, reject) => {
    if (!window.FB) {
      reject(new Error("Facebook SDK no cargado. Recarga la pagina."));
      return;
    }
    // Set a timeout in case FB dialog doesn't return
    const timeout = setTimeout(() => {
      reject(new Error("La conexion con Facebook tardo demasiado. Verifica que la app de Facebook tiene configurada la URL de redireccion correcta."));
    }, 120000);

    window.FB.login(
      (response) => {
        clearTimeout(timeout);
        if (response.authResponse) {
          const { accessToken, userID } = response.authResponse;
          // Get user info + pages
          window.FB.api("/me", { fields: "name,email" }, (userInfo) => {
            window.FB.api(
              "/me/accounts",
              { fields: "name,access_token,id,instagram_business_account" },
              (pagesResp) => {
                if (pagesResp?.error) {
                  reject(new Error(pagesResp.error.message || "Error al obtener paginas de Facebook"));
                  return;
                }
                resolve({
                  accessToken,
                  userID,
                  userName: userInfo?.name || "",
                  userEmail: userInfo?.email || "",
                  pages: pagesResp?.data || [],
                });
              }
            );
          });
        } else {
          reject(new Error("El usuario cancelo la conexion con Facebook"));
        }
      },
      {
        scope:
          "pages_show_list,pages_manage_posts,pages_read_engagement,instagram_basic,instagram_content_publish",
      }
    );
  });
}

export function fbGetLoginStatus() {
  return new Promise((resolve) => {
    if (!window.FB) {
      resolve(null);
      return;
    }
    window.FB.getLoginStatus((response) => {
      if (response.status === "connected") {
        resolve(response.authResponse);
      } else {
        resolve(null);
      }
    });
  });
}

export function fbLogout() {
  return new Promise((resolve) => {
    if (!window.FB) {
      resolve();
      return;
    }
    window.FB.logout(() => resolve());
  });
}
